(() => {
    const baseUrl = window.location.origin;

    if (window.Shopify) {
        window.Shopify.routes = window.Shopify.routes || {};
        window.Shopify.routes.root = '/';
    }

    if (window.Abra?.config) {
        window.Abra.config.baseUrl = baseUrl;
    }

    window.addEventListener(
        'abraLoaded',
        () => {
            if (window.Abra?.config) {
                window.Abra.config.baseUrl = baseUrl;
            }
        }
    );

    const getHandle = href => href?.split('/products/')[1]
        ?.split('?')[0]
        ?.split('/')[0];

    const applyToSection = (containerSelector, priceSelector = '.price') => {
        document.querySelectorAll(containerSelector)
            .forEach(
                card => {
                    const link = card.querySelector('a[href*="/products/"]');

                    if (!link) {
                        return;
                    }

                    const handle = getHandle(link.getAttribute('href'));

                    if (!handle) {
                        return;
                    }

                    card.setAttribute('data-product-handle', handle);

                    card.setAttribute('data-abra-container', 'true');

                    const price = card.querySelector(priceSelector);

                    if (price) {
                        price.setAttribute('data-product-handle', handle);
                    }
                }
            );

        setTimeout(
            () => {
                if (window.Abra?.render) {
                    window.Abra.render();
                }
            },
            100
        );
    };

    const applyHandles = () => {
        const selectors = [
            {
                container: '.featured-collection__product-card',
                price: '.featured-collection__product-price'
            },
            {
                container: '.one-third.column.thumbnail',
                price: '.price'
            },
            {
                container: '.grid__item',
                price: '.price'
            },
            {
                container: '.product-card',
                price: '.price'
            },
            {
                container: '.card-wrapper',
                price: '.price'
            },
            {
                container: '[data-product-item]',
                price: '.price'
            },
            {
                container: '.quick-add-modal .product-item',
                price: '.price'
            },
            {
                container: '.predictive-search__item',
                price: '.price'
            },
            {
                container: '.cart-drawer__item',
                price: '.price'
            },
            {
                container: '.upsell-item',
                price: '.price'
            }
        ];

        selectors.forEach(
            ({ container, price: priceSelector }) => {
                document.querySelectorAll(container)
                    .forEach(
                        card => {
                            const link = card.querySelector('a[href*="/products/"]');

                            if (!link) {
                                return;
                            }

                            const handle = getHandle(link.getAttribute('href'));

                            if (!handle) {
                                return;
                            }

                            card.setAttribute('data-product-handle', handle);

                            card.setAttribute('data-abra-container', 'true');

                            const price = card.querySelector(priceSelector);

                            if (price) price.setAttribute('data-product-handle', handle);
                        }
                    );
            });

        setTimeout(
            () => {
                if (window.Abra?.render) {
                    window.Abra.render();
                }
            },
            100
        );
    };

    const separatePriceFromDays = () => {
        const btnText = document.querySelector('.cc-rc-plans-radios__submit-btn-text');

        if (!btnText) {
            return;
        }

        if (btnText.querySelector('.rc-price')) {
            return;
        }

        const text = btnText.textContent.trim();

        const match = text.match(/^(.*?)(\$[\d.,]+)(.*)$/);

        if (match) {
            const [, before, price, after] = match;

            btnText.innerHTML = `${before}<span class="rc-price" data-abra-selector=".rc-price">${price}</span>${after}`;
        }
    };

    const watchRechargeChanges = () => {
        const submitBtn = document.querySelector('.action_button.add_to_cart');

        if (!submitBtn) {
            return;
        }

        new MutationObserver(
            () => {
                setTimeout(separatePriceFromDays, 50);
            }
        ).observe(
            submitBtn,
            {
                childList: true,
                characterData: true,
                subtree: true
            }
        );
    };

    const setSellingPlanFlag = () => {
        const subsaveChecked = document.querySelector('[data-option-subsave] input:checked');

        const onetimeChecked = document.querySelector('[data-option-onetime] input:checked');

        if (window.Abra) {
            if (subsaveChecked) {
                window.Abra.useSellingPlanPriceOnProductBlock = true;
            } else if (onetimeChecked) {
                window.Abra.useSellingPlanPriceOnProductBlock = false;
            }
        }
    };

    const addRechargeClickListeners = () => {
        document.querySelectorAll('[data-option-subsave]')
            .forEach(
                option => {
                    const input = option.querySelector('input[type="radio"]');

                    if (!input) {
                        return;
                    }

                    input.addEventListener(
                        'change',
                        () => {
                            if (!input.checked) {
                                return;
                            }
                            setTimeout(
                                () => {
                                    if (window.Abra) {
                                        window.Abra.useSellingPlanPriceOnProductBlock = true;
                                    }
                                    separatePriceFromDays();

                                    if (window.Abra?.render) {
                                        window.Abra.render();
                                    }
                                },
                                100
                            );
                        }
                    );
                }
            );

        document.querySelectorAll('[data-option-onetime]')
            .forEach(
                option => {
                    const input = option.querySelector('input[type="radio"]');

                    if (!input) {
                        return;
                    }

                    input.addEventListener(
                        'change',
                        () => {
                            if (!input.checked) {
                                return;
                            }

                            setTimeout(
                                () => {
                                    if (window.Abra) {
                                        window.Abra.useSellingPlanPriceOnProductBlock = false;
                                    }

                                    separatePriceFromDays();

                                    if (window.Abra?.render) {
                                        window.Abra.render();
                                    }
                                },
                                100
                            );
                        }
                    );
                }
            );

        const planDropdown = document.querySelector('[data-plans-dropdown]');

        if (planDropdown) {
            planDropdown.addEventListener(
                'change',
                () => {
                    setTimeout(
                        () => {
                            separatePriceFromDays();

                            if (window.Abra?.render) {
                                window.Abra.render();
                            }
                        },
                        100
                    );
                }
            );
        }

        document.querySelectorAll('.cc-rc-plans-radios__input')
            .forEach(
                radio => {
                    radio.addEventListener(
                        'change',
                        () => {
                            setTimeout(
                                () => {
                                    separatePriceFromDays();

                                    if (window.Abra?.render) {
                                        window.Abra.render();
                                    }
                                },
                                100
                            );
                        }
                    )
                }
            );
    }

    const renderOnRechargeWidget = () => {
        const priceElement = document.querySelector('.container-product .product__price-modal');

        if (!priceElement) {
            return;
        }

        new MutationObserver(
            (mutations, observer) => {
                if (document.querySelector('.rc-container-wrapper')) {
                    setSellingPlanFlag();
                    separatePriceFromDays();
                    watchRechargeChanges();
                    addRechargeClickListeners();

                    setTimeout(
                        () => {
                            if (window.Abra?.render) {
                                window.Abra.render();
                            }
                        },
                        500
                    );

                    observer.disconnect();
                }
            }
        ).observe(
            priceElement,
            {
                childList: true,
                subtree: true
            }
        );
    };

    const init = () => {
        applyHandles();

        if (!window.Abra?.render) {
            setTimeout(
                () => {
                    if (window.Abra?.render) {
                        window.Abra.render();
                    }
                },
                1500
            );
        }

        renderOnRechargeWidget();
    };

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            init
        );
    } else {
        init();
    }

    const watchSelectors = [
        '.featured-collection__product-card',
        '.one-third.column.thumbnail',
        '.grid__item',
        '.product-card',
        '.card-wrapper',
        '[data-product-item]',
        '.quick-add-modal',
        '.predictive-search__item',
        '.cart-drawer__item',
        '.upsell-item'
    ].join(',');

    new MutationObserver(
        mutations => {
            if (mutations.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1 && n.matches?.(watchSelectors)))) {
                setTimeout(
                    applyHandles,
                    100
                );
            }
        }
    ).observe(
        document.querySelector('.container-product .product__price-modal'),
        {
            childList: true,
            subtree: true
        }
    );

    window.AbraEmuaid = {
        applyToSection,
        applyHandles,
        getHandle
    };
})();
